
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  public captchaId = "80c695702816425cc4995b8aa38247b8";

  public mounted() {
    this.init();
  }

  public init() {
    (window as any).initGeetest4(
      {
        captchaId: this.captchaId,
        product: "bind",
      },
      (captcha: any) => {
        captcha.onReady(() => {
          // console.log("验证码加载成功");
        });
        captcha.onSuccess(() => {
          const result2: any = captcha.getValidate();
          const param: any = {
            captcha_output: result2.captcha_output,
            gen_time: result2.gen_time,
            lot_number: result2.lot_number,
            pass_token: result2.pass_token,
          };
          this.$emit("getVerifyParam", param);
          captcha.reset(); // 调用该接口进行重置
        });
        captcha.onError(() => {
          // console.log("验证失败");
        });
        captcha.showCaptcha();
        captcha.onClose(() => {
          // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
          this.$emit("update:verifyShow", false);
        });
      }
    );
  }
}
